"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Log = _interopRequireDefault(require("../utils/Log"));

var _Error = _interopRequireDefault(require("./Error"));

var _Plan = _interopRequireDefault(require("./Plan"));

var _Amplitude = require("./Amplitude");

var _Form = _interopRequireDefault(require("./Form"));

var _FormRow = _interopRequireDefault(require("./FormRow"));

var _FormNumberInput = _interopRequireDefault(require("./FormNumberInput"));

var _PaymentCalculatorModal = _interopRequireDefault(require("./PaymentCalculatorModal"));

var _PaymentCalculatorEstimatedModal = _interopRequireDefault(require("./PaymentCalculatorEstimatedModal"));

var _RateBar = _interopRequireDefault(require("./RateBar"));

var _PaymentCalculatorModule = _interopRequireDefault(require("./PaymentCalculator.module.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Beep = _interopRequireDefault(require("../utils/Beep"));

var _lodash = _interopRequireDefault(require("lodash.debounce"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var pageName = "Payment Calculator Page";
var rates = ['Lowest', '10%', '15%', '20%', '25%'];
var MIN_AMOUNT = 500;
var MAX_AMOUNT = 25000;
var logAmplitudeDebounced = (0, _lodash["default"])(_Amplitude.logAmplitudeEvent, 3000);

var PaymentCalculator = /*#__PURE__*/function (_React$Component) {
  _inherits(PaymentCalculator, _React$Component);

  var _super = _createSuper(PaymentCalculator);

  function PaymentCalculator() {
    var _this;

    _classCallCheck(this, PaymentCalculator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      loanAmount: '3000',
      apr: 'Lowest',
      errors: {},
      errorMessage: "",
      plans: [{
        id: '3',
        months: 3,
        amount: 0,
        interest: 0,
        apr: 0,
        minApr: 0
      }, {
        id: '6',
        months: 6,
        amount: 0,
        interest: 0,
        apr: 0,
        minApr: 4.9
      }, {
        id: '12',
        months: 12,
        amount: 0,
        interest: 0,
        apr: 0,
        minApr: 5.9
      }, {
        id: '24',
        months: 24,
        amount: 0,
        interest: 0,
        apr: 0,
        minApr: 7.9
      }, {
        id: '36',
        months: 36,
        amount: 0,
        interest: 0,
        apr: 0,
        minApr: 8.9
      }, {
        id: '60',
        months: 60,
        amount: 0,
        interest: 0,
        apr: 0,
        minApr: 9.9
      }]
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnRateSelected", function (apr) {
      _this.setState({
        apr: apr
      });

      _this.calculate(null, apr);

      (0, _Amplitude.logAmplitudeEvent)('APR selected', _objectSpread(_objectSpread({}, _this.logProps), {}, {
        apr: apr
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "getEditValue", function (name) {
      return _this.state[name];
    });

    _defineProperty(_assertThisInitialized(_this), "handleOnChange", function (e) {
      var val = e.target.value;
      var name = e.target.name;

      _this.setError(name, "");

      if (name === 'loanAmount' && val) {
        val = val.replace(/^\$0+/, '');
        var amount = Number(val.replace(/\D/g, ''));

        if (amount > MAX_AMOUNT) {
          (0, _Beep["default"])();

          _this.setError('loanAmount', 'Enter amount between $500 and $25,000');

          _this.setState({
            invalidAmount: true
          });

          setTimeout(function () {
            _this.setState({
              invalidAmount: false
            });

            _this.setError('loanAmount', '');
          }, 1500);
          return;
        }

        logAmplitudeDebounced('Amount entered', _objectSpread(_objectSpread({}, _this.logProps), {}, {
          amount: amount
        }));
      }

      _this.setState(_defineProperty({}, name, val));

      if (name === 'loanAmount') {
        if (!val) {
          val = '0';
        }

        _this.calculate(val);
      } else {
        _this.calculate();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "calculate", function (loanAmount, apr) {
      if (!loanAmount) {
        loanAmount = _this.state.loanAmount;
      }

      if (!apr) {
        apr = _this.state.apr;
      }

      var amount = Number(loanAmount.replace(/\D/g, ''));

      if (amount < MIN_AMOUNT || amount > MAX_AMOUNT) {
        _this.setError('loanAmount', 'Enter amount between $500 and $25,000');

        _this.setState({
          showPlans: false
        });

        return;
      }

      var plans = _toConsumableArray(_this.state.plans);

      plans.forEach(function (plan) {
        if (apr === 'Lowest') {
          plan.apr = plan.minApr;
        } else {
          plan.apr = Number(apr.replace(/\D/g, ''));
        }

        var r = plan.apr / 12 / 100;

        if (r > 0) {
          var n = plan.months;
          var x = Math.pow(1 + r, n);
          var y = r * x;
          var z = x - 1;
          plan.amount = y / z * amount;
        } else {
          plan.amount = amount / plan.months;
        }

        plan.interest = plan.amount * plan.months - amount;
      });

      _this.setState({
        plans: plans,
        showPlans: true
      });
    });

    return _this;
  }

  _createClass(PaymentCalculator, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.scrollTo(0, 0);
      this.logProps = {
        page: pageName
      };
      this.calculate();
    }
  }, {
    key: "setError",
    value: function setError(name, error) {
      this.setState({
        errors: _objectSpread(_objectSpread({}, this.state.errors), {}, _defineProperty({}, name, error))
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var amountClasses = (0, _classnames["default"])((_classNames = {
        "form-control": true
      }, _defineProperty(_classNames, _PaymentCalculatorModule["default"].enabled, true), _defineProperty(_classNames, _PaymentCalculatorModule["default"].invalidDisabled, true), _defineProperty(_classNames, _PaymentCalculatorModule["default"].amount, true), _defineProperty(_classNames, _PaymentCalculatorModule["default"].invalidAmount, this.state.invalidAmount), _classNames));
      var amountLabelClasses = (0, _classnames["default"])(_defineProperty({
        "bmd-label-floating": true
      }, _PaymentCalculatorModule["default"].amountLabel, true));
      var loanAmount = Number(this.state.loanAmount.replace(/\D/g, ''));

      _Log["default"].info(this.props, "PaymentCalculatorPage props");

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: _PaymentCalculatorModule["default"].hint
      }, "Enter your loan details to\xA0see\xA0", /*#__PURE__*/_react["default"].createElement("span", {
        className: _PaymentCalculatorModule["default"].clickable,
        "data-toggle": "modal",
        "data-target": "#paymentCalculatorEstimatedModal",
        onClick: function onClick() {
          (0, _Amplitude.logAmplitudeEvent)("Pressed estimated link", _this2.logProps);
        }
      }, "estimated"), " monthly\xA0payment\xA0options."), /*#__PURE__*/_react["default"].createElement(_Error["default"], {
        pageName: pageName
      }, this.state.errorMessage), /*#__PURE__*/_react["default"].createElement(_Form["default"], null, /*#__PURE__*/_react["default"].createElement(_FormRow["default"], null, /*#__PURE__*/_react["default"].createElement(_FormNumberInput["default"], {
        className: amountClasses,
        labelClasses: amountLabelClasses,
        name: "loanAmount",
        label: "",
        value: this.getEditValue("loanAmount"),
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
        errors: this.state.errors,
        inputMode: "numeric",
        pattern: "[0-9]*",
        thousandSeparator: true,
        prefix: '$',
        decimalScale: 0,
        allowNegative: false
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: _PaymentCalculatorModule["default"].rateInfo
      }, "Select Interest Rate (APR)", /*#__PURE__*/_react["default"].createElement("span", {
        "data-toggle": "modal",
        "data-target": "#paymentCalculatorModal",
        className: "material-icons",
        onClick: function onClick() {
          return (0, _Amplitude.logAmplitudeEvent)('Pressed info link', _this2.logProps);
        }
      }, "info_outline")), /*#__PURE__*/_react["default"].createElement(_RateBar["default"], {
        rates: rates,
        onRateSelected: this.handleOnRateSelected
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: _PaymentCalculatorModule["default"].noTricks
      }, "No tricks: no origination fees, prepayment\xA0fees, or\xA0late\xA0fees."), /*#__PURE__*/_react["default"].createElement("div", {
        className: _PaymentCalculatorModule["default"].plans
      }, this.state.showPlans && this.state.plans.map(function (item) {
        if (item.months < 36 || loanAmount >= 5000 && item.months === 36 || loanAmount >= 8000 && item.months === 60) {
          return /*#__PURE__*/_react["default"].createElement("div", {
            key: item.id
          }, /*#__PURE__*/_react["default"].createElement(_Plan["default"], {
            item: item
          }));
        } else {
          return null;
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: _PaymentCalculatorModule["default"].interested
      }, /*#__PURE__*/_react["default"].createElement("b", null, "Interested?"), " To apply, contact a business offering Wisetack\xA0financing."), /*#__PURE__*/_react["default"].createElement("div", {
        className: _PaymentCalculatorModule["default"].bottom
      }, "All loans are subject to credit approval. Wisetack loans are\xA0made by Hatch Bank."), /*#__PURE__*/_react["default"].createElement(_PaymentCalculatorModal["default"], null), /*#__PURE__*/_react["default"].createElement(_PaymentCalculatorEstimatedModal["default"], null));
    }
  }]);

  return PaymentCalculator;
}(_react["default"].Component);

var _default = PaymentCalculator;
exports["default"] = _default;